import styled from "styled-components";

// Campos de formulario de las pantallas del alta de empresa (estilo del mockup)
export const FieldGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 20px 24px;

    @media screen and (max-width: 991px)
    {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    @media screen and (max-width: 599px)
    {
        grid-template-columns: minmax(0, 1fr);
    }
`;

export const SubsectionTitle = styled.h4`
    margin: 8px 0 0;
    font-size: 17px;
    font-weight: 700;
    color: #2a4143;
    cursor: default;
`;

export const Field = styled.label`
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;

    > span
    {
        font-size: 14px;
        font-weight: 600;
        color: #2a4143;
    }

    > span b
    {
        color: ${(props) => props.theme?.palette?.themePrimary || "#CC214F"};
    }
`;

const fieldControlStyles = `
    height: 48px;
    border: 1px solid #D6DEE2;
    border-radius: 10px;
    padding: 0 14px;
    font: inherit;
    font-size: 15px;
    color: #2a4143;
    background: #ffffff;
    box-sizing: border-box;
    width: 100%;
    min-width: 0;
`;

export const Input = styled.input`
    ${fieldControlStyles}

    &:focus
    {
        outline: 2px solid ${(props) => props.theme?.palette?.themePrimary || "#CC214F"};
        outline-offset: 1px;
    }
`;

export const Select = styled.select`
    ${fieldControlStyles}

    &:focus
    {
        outline: 2px solid ${(props) => props.theme?.palette?.themePrimary || "#CC214F"};
        outline-offset: 1px;
    }
`;

// Texto libre de varias líneas (motivos de apertura del KYC)
export const TextArea = styled.textarea`
    ${fieldControlStyles}
    height: auto;
    min-height: 96px;
    padding: 12px 14px;
    resize: vertical;

    &:focus
    {
        outline: 2px solid ${(props) => props.theme?.palette?.themePrimary || "#CC214F"};
        outline-offset: 1px;
    }
`;

export const TwoFieldRow = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 20px 24px;

    @media screen and (max-width: 599px)
    {
        grid-template-columns: minmax(0, 1fr);
    }
`;

export const FieldError = styled.small`
    font-size: 13px;
    color: #a4262c;
`;

export const ReadingNotice = styled.p`
    margin: 0;
    padding: 12px 16px;
    border-radius: 10px;
    background: #FFF8E1;
    color: #7A5B00;
    font-size: 14px;
    font-weight: 600;
`;

export const BlockedNotice = styled.p`
    margin: 0;
    padding: 12px 16px;
    border-radius: 10px;
    background: #FDECEE;
    color: #a4262c;
    font-size: 14px;
    font-weight: 600;
`;
